export enum MappingDisplayItemTypes {
    GROUP_TOTAL = 'GROUP_TOTAL',
    SUB_FLI = 'SUB_FLI',
    SUBTOTAL = 'SUBTOTAL',
    FLI = 'FLI',
    ACCOUNT = 'ACCOUNT',
    RECLASSES = 'RECLASSES',
}
